import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { hasPath, path } from 'ramda';
import { Controller, useFormContext } from 'react-hook-form';

const OrganizationEmailInputs = () => {
	const {
		control,
		formState: { errors }
	} = useFormContext();

	return (
		<>
			<Grid item xs={12}>
				<Controller
					name="organization"
					control={control}
					render={({ field }) => (
						<TextField
							fullWidth
							{...field}
							variant="outlined"
							label="Organization"
							helperText={path(['organization', 'message'], errors)}
							error={hasPath(['organization', 'message'], errors)}
						/>
					)}
				/>
			</Grid>
			<Grid item xs={12}>
				<Controller
					name="email"
					control={control}
					render={({ field }) => (
						<TextField
							fullWidth
							variant="outlined"
							label="Email"
							{...field}
							helperText={path(['email', 'message'])(errors)}
							error={hasPath(['email', 'message'], errors)}
						/>
					)}
				/>
			</Grid>
		</>
	);
};

export default OrganizationEmailInputs;
